import { NgModule } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { SharedModule } from '../../shared/shared.module';
import { BackofficeRoutingModule } from './backoffice-routing.module';
import { BackofficeLayoutComponent } from './layout/layout.component';
import { InicioComponent } from './modules/inicio/inicio.component';
import { PedidosModule } from './modules/pedidos/pedidos.module';
import { ConfirmarDialogComponent } from './shared/components/dialogs/confirmar-dialog/confirmar-dialog.component';
import { PerfilComponent } from './shared/components/perfil/perfil.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SidenavComponent } from './shared/sidenav/sidenav.component';
import { getSpanishPaginator } from './shared/utils/paginador';

@NgModule({
  declarations: [
    SidenavComponent,
    FooterComponent,
    InicioComponent,
    ConfirmarDialogComponent,
    PerfilComponent,
    BackofficeLayoutComponent,
  ],
  imports: [BackofficeRoutingModule, SharedModule, PedidosModule],
  providers: [{ provide: MatPaginatorIntl, useValue: getSpanishPaginator() }],
})
export class BackofficeModule {}
